import React, {
  FC,
  ReactElement,
  useEffect,
  useState,
  ReactNode,
  useRef,
} from "react";
import { createSelectorQuery } from "@tarojs/taro";
import { View } from "@tarojs/components";
import classNames from "classnames";
import Item from "./TabItem";

/**
 * Tab切换
 *
 * @param children  //子组件
 * @param animated  //是否开启转场动画
 * @param selectIndex  //默认选中第几个
 * @param lineColor   //下划线颜色
 * @param titleActiveColor   //标题选中态颜色
 * @param titleInctiveColor   //标题默认态颜色
 * @param onChange   //切换回调事件
 * @param content   //item公共节点
 *
 */

export interface TabProps {
  children: ReactElement[];
  animated?: boolean;
  // initIndex?: number;
  lineColor?: string;
  titleActiveColor?: string;
  titleInctiveColor?: string;
  onChange?: (index: number) => void;
  content?: string | ReactNode;
  selectIndex: number;
}

export interface TabsComponent<P = {}> extends FC<P> {
  Item: typeof Item;
}

const XHTabs: TabsComponent<TabProps> = props => {
  const {
    children = [],
    animated = false,
    // initIndex = 0,
    lineColor = "#F6AB00",
    titleActiveColor = "#333",
    titleInctiveColor = "#999",
    onChange,
    content,
    selectIndex = 0,
  } = props;

  // const [selectIndex, setSelectIndex] = useState(initIndex);
  const [tabWdith, setTabWdith] = useState(0);
  const [tabContentHeight, setTabContentHeight] = useState(0);
  const [tabSlotHeight, setTabSlotHeight] = useState(0);

  const itemNavRef = useRef<(HTMLLIElement | null)[]>([]);
  const itemContentRef = useRef<(HTMLDivElement | null)[]>([]);
  const itemSlotRef = useRef<(HTMLDivElement | null)[]>([]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (process.env.TARO_ENV === "h5") {
        const el = itemNavRef.current[selectIndex];
        if (el) {
          const rect = el.getBoundingClientRect();
          console.log("el", rect);
          setTabWdith(rect.width);
        }
        const elSlot = itemSlotRef.current[0];
        if (elSlot) {
          const rect = elSlot.getBoundingClientRect();
          console.log("elSlot", rect);
          setTabSlotHeight(rect.height);
        }

        const elitem = itemContentRef.current[selectIndex];
        if (elitem) {
          const rect = elitem.getBoundingClientRect();
          console.log("elitem", rect);
          setTabContentHeight(rect.height);
        }
        clearTimeout(timer);
        return;
      }

      const query = createSelectorQuery();
      query.selectAll(".xh-tabbar-nav-item").boundingClientRect();
      query.selectAll(".xh-tabbar-content-item").boundingClientRect();
      query.selectAll(".xh-tabbar-content-slot").boundingClientRect();

      query.exec(res => {
        if (!res[0][selectIndex]) return;
        const width: number = res[0][selectIndex].width;
        setTabWdith(width);

        if (!res[1][selectIndex]) return;
        setTabContentHeight(res[1][selectIndex].height);

        if (!res[2][selectIndex]) return;
        setTabSlotHeight(res[2][selectIndex].height);
        clearTimeout(timer);
      });
    }, 300);
    console.log(children.length);
  }, [selectIndex, children]);

  const handleClick = (index: number): void => {
    // setSelectIndex(index);
    const query = createSelectorQuery();
    query.selectAll(".xh-tabbar-content-item").boundingClientRect();
    query.selectAll(".xh-tabbar-content-slot").boundingClientRect();
    query.exec(res => {
      if (!res[0][index]) return;
      const height: number = res[0][index].height;
      setTabContentHeight(height);
      if (!res[1][index]) return;
      setTabSlotHeight(res[1][index].height);
    });

    onChange && onChange(index);
  };

  function renderLine(): ReactElement | null {
    const left: number = tabWdith / 2 + selectIndex * tabWdith;
    return (
      <div
        className={classNames("xh-tabbar-nav-line", {
          "xh-tabbar-nav-line-active": animated,
        })}
        style={{
          background: `${lineColor}`,
          transform: `translateX(${left}px) translate(-50%, -50%)`,
          WebkitTransform: `translateX(${left}px) translate(-50%, -50%)`,
        }}
      />
    );
  }

  return (
    <View className="xh-tabbar">
      <View className="xh-tabbar-nav">
        {children.map((child, index) => (
          <View
            key={index}
            // @ts-ignore
            dataTrackId={
              child.props.dataTrackId || `xh-tabbar-nav-item-${index}`
            }
            ref={el => (itemNavRef.current[index] = el)}
            className="xh-tabbar-nav-item"
            style={{
              color:
                selectIndex === index ? titleActiveColor : titleInctiveColor,
            }}
            onClick={() => handleClick(index)}
          >
            {child.props.TabItemComponent
              ? child.props.TabItemComponent
              : child.props.title}
          </View>
        ))}
        {renderLine()}
      </View>
      <View
        className="xh-tabbar-content"
        style={{
          width: `${children.length * 100}%`,
          height:
            tabContentHeight + tabSlotHeight
              ? `${tabContentHeight + tabSlotHeight}px`
              : "auto",
        }}
      >
        {content && (
          <View className="xh-tabbar-content-slot" ref={itemSlotRef}>
            {content}
          </View>
        )}
        {children.map((child, index) => (
          <View
            key={index}
            ref={el => (itemContentRef.current[index] = el)}
            className={classNames("xh-tabbar-content-item", {
              "xh-tabbar-content-item-dispaly":
                selectIndex !== index && !animated,
              "xh-tabbar-content-item-active": selectIndex === index,
            })}
            style={{
              transform: animated ? `translateX(-${selectIndex * 100}%)` : "",
            }}
          >
            {child.props.children}
          </View>
        ))}
      </View>
    </View>
  );
};

XHTabs.Item = Item;

export default XHTabs;
export const TabItem = Item;
